import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import svgIcon from '@/components/icon/svg'

function renderIconContent(h) {
  if (this.iconSVG) {
    return h(
      squircle,
      {
        props: {
          color: this.color
        }
      },
      [
        h(
          svgIcon,
          {
            props: {
              value: this.iconSVG,
              color: this.color,
              size: 20
            }
          }
        )
      ]
    )
  } else {
    return h(
      squircle,
      {
        props: {
          icon: this.icon,
          color: this.color
        }
      }
    )
  }
}
function renderIcon(h) {
  return h(
    'div',
    {
      class: 'info__icon'
    },
    [ renderIconContent.call(this, h) ]
  )
}

function renderContent(h) {
  if (this.$slots.default) {
    return this.$slots.default
  }

  return h(
    'div',
    {
      class: 'info__text',
      domProps: { innerHTML: this.value }
    }
  )
}

function renderButton(h) {
  if (this.hasButton) {
    return h(
      'div',
      {
        class: 'info__button'
      },
      [
        h(
          button,
          {
            props: {
              label: this.button.label,
              icon: this.button.icon,
              iconSVG: this.button.iconSVG,
              size: this.button.size,
              mode: this.button.mode,
              color: this.button.color,
              tooltip: this.button.tooltip,
              loading: this.button.loading,
              disabled: this.button.disabled
            },
            on: {
              click: this.buttonClickHandler
            }
          }
        )
      ]
    )
  }
}

export default function(h) {
  if (this.hasContent) {
    return h(
      'div',
      {
        class: this.class
      },
      [
        renderIcon.call(this, h),
        renderContent.call(this, h),
        renderButton.call(this, h)
      ]
    )
  }
}
